import script from "./AlertsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlertsPage.vue?vue&type=script&setup=true&lang=ts"

import "./AlertsPage.vue?vue&type=style&index=0&id=063151cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-063151cc"]])

export default __exports__